var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLirariLandingPageMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 355,
    viewBox: "0 0 232 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9527 317.468C-1.84064 292.419 164.502 208.779 169.528 235.95",
    stroke: "black",
    strokeWidth: 3,
    strokeDasharray: "6 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.219 339.893C119.428 339.893 147.97 311.35 147.97 276.141C147.97 240.932 119.428 212.39 84.219 212.39C49.01 212.39 20.4675 240.932 20.4675 276.141C20.4675 311.35 49.01 339.893 84.219 339.893Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.133 3.99999V10.2888C153.007 58.0932 240.393 131.356 227.751 241C209.9 144.672 186.733 145.142 149.133 127.405V10.2888C148.959 8.14148 148.953 6.04555 149.133 3.99999Z",
    fill: "url(#paint0_linear_61_321)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.987 3.51288L147.994 272.513M149.133 3.99999V10.2888M149.133 3.99999C148.953 6.04555 148.959 8.14148 149.133 10.2888M149.133 3.99999V127.405M149.133 3.99999C144.955 51.5848 240.961 126.431 227.751 241M149.133 10.2888C153.007 58.0932 240.393 131.356 227.751 241M149.133 10.2888V127.405M227.751 241C209.9 144.672 186.733 145.142 149.133 127.405M84.219 339.893C119.428 339.893 147.97 311.35 147.97 276.141C147.97 240.932 119.428 212.39 84.219 212.39C49.01 212.39 20.4675 240.932 20.4675 276.141C20.4675 311.35 49.01 339.893 84.219 339.893Z",
    stroke: "url(#paint1_linear_61_321)",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0063 263.675C54.0673 304.836 74.6683 317.579 116.942 327.043M34.8751 241.6C64.7963 280.754 94.0205 298.226 134.862 309.124M53.5739 224.2C83.3473 263.029 103.547 275.69 144.077 286.581M78.0999 215.725C98.1794 244.863 112.603 253.75 142.393 260.04M118.011 226.106C44.7122 217.157 16.8146 270.153 49.938 326.005M118.164 226.567C72.6045 236.597 41.868 287.601 49.938 326.264M118.617 226.19L50.5744 326.436M118.5 226.278C127.496 273.754 91.7054 321.979 50.407 326.867M118.555 225.988C157.499 294.085 118.782 340.452 50.3306 326.816",
    stroke: "url(#paint2_linear_61_321)",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.375 235.532C174.169 260.581 7.82616 344.221 2.79956 317.05",
    stroke: "black",
    strokeWidth: 3,
    strokeDasharray: "6 12"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_321",
    x1: 124.734,
    y1: 3.51288,
    x2: 124.734,
    y2: 339.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9E0EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#8830C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_321",
    x1: 124.734,
    y1: 3.51288,
    x2: 124.734,
    y2: 339.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9E0EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#8830C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_321",
    x1: 84.5417,
    y1: 215.725,
    x2: 84.5417,
    y2: 329.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9E0EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#8830C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLirariLandingPageMobileLogo);
export default __webpack_public_path__ + "static/media/lirari-landing-page-mobile-logo.600d6a2775f29b3ac1d55481f456ff27.svg";
export { ForwardRef as ReactComponent };